import { Button } from '@mui/material';
import { HeroV2Widget as ComponentLibraryHeroV2Widget } from '@orcha/micro-library-widgets-ui';
import { SearchAutocomplete } from 'src/components/Search';
import { SearchProvider } from 'src/store';
import { logEventAnalytic } from 'src/utilities/logAnalytics';
import theme from 'src/themes/theme';
import Image from 'next/image';
import { truncateText } from 'src/utilities/stringFormat';
import { useRouter } from 'next/router';
import { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { HeroV2WidgetProps } from './HeroV2Widget.types';
import { ButtonsContainer, SearchContainer } from './HeroV2Widget.styles';

const HeroV2Widget = (props: HeroV2WidgetProps) => {
  const {
    search,
    bodyHtml,
    imageUrl,
    hasContentBackground,
    styleOverrides,
    primaryButton,
    secondaryButton,
  } = props;
  const { t } = useTranslation('search');
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { placeholderText, buttonText } = search || {};
  const includeSearch = search?.isHidden !== true;

  const router = useRouter();

  const invokeSearch = () => {
    logEventAnalytic({
      category: 'Search',
      action: 'Searched for an app using the search bar - microsite',
      label: `${searchTerm}`,
    });

    router.push({
      pathname: '/search',
      query: { search: searchTerm },
    });
  };

  return (
    <ComponentLibraryHeroV2Widget
      FlexibleImageComponent={Image}
      bodyHtml={bodyHtml}
      imageUrl={imageUrl}
      hasContentBackground={hasContentBackground}
      styleOverrides={styleOverrides}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
    >
      {includeSearch && (
        <SearchProvider>
          <SearchContainer>
            <SearchAutocomplete
              placeholderText={
                placeholderText && placeholderText?.length > 0
                  ? search?.placeholderText
                  : undefined
              }
              onInputChanged={setSearchTerm}
              onFreeTextSubmit={invokeSearch}
            />
            <ButtonsContainer>
              <Button
                color="primary"
                data-testid="search-button"
                variant="contained"
                onClick={invokeSearch}
                fullWidth
                sx={{
                  [theme.breakpoints.up('sm')]: {
                    minWidth: '180px',
                  },
                }}
              >
                {buttonText && buttonText?.length > 0
                  ? truncateText(buttonText, 35)
                  : t('searchButton')}
              </Button>
            </ButtonsContainer>
          </SearchContainer>
        </SearchProvider>
      )}
    </ComponentLibraryHeroV2Widget>
  );
};

export default HeroV2Widget;
